import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25.592 14.624",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M76.8,256c-4.679,0-8.323,2.788-12.8,7.312,3.85,3.867,7.084,7.312,12.8,7.312s9.906-4.364,12.8-7.232C86.633,260.033,82.44,256,76.8,256Zm0,12.528a5.216,5.216,0,1,1,5.118-5.216A5.175,5.175,0,0,1,76.8,268.528Zm0-7.044a1.834,1.834,0,0,1,.434-1.183,2.729,2.729,0,0,0-.434-.034,3.045,3.045,0,1,0,2.988,3.045c0-.131-.011-.263-.023-.394a1.83,1.83,0,0,1-2.965-1.434Z",
		transform: "translate(-64 -256)"
	})
});
export default SvgEyeIcon;
